import { initialState } from "./contractPricingSlice";

const contractPricingReducers = {
    setPriceIndex: (state, action) => {
        const { selectionId, backPrices, layPrices } = action.payload;
        state.priceIndex[selectionId] = {
            backPrices,
            layPrices
        };
    },
    setMarketIndex: (state, action) => {
        const { status, deleted, marketId } = action.payload;
        state.marketIndex[marketId] = {
            status,
            deleted
        };
    },
    setMatchedAmount: (state, action) => {
        const { againstSideAmount, forSideAmount, marketId } = action.payload;
        state.matchedAmountIndex[marketId] = {
            againstSideAmount,
            forSideAmount
        };
    },
    resetStore: (state) => {
        const { marketIndex, priceIndex, matchedAmountIndex } = initialState;
        state.marketIndex = marketIndex;
        state.priceIndex = priceIndex;
        state.matchedAmountIndex = matchedAmountIndex;
    }
};
export default contractPricingReducers;
